import { Link } from 'react-router-dom';
import { IconChevronRight, IconMoon, IconSun } from '@tabler/icons-react';

export default function AccountSettingsList({
    theme,
    setTheme,
    isUserSet,
    onChangePassword,
    onLogout,
}) {
    return (
        <section className="account-page__section" aria-labelledby="account-settings-heading">
            <h3 id="account-settings-heading" className="account-page__section-label">
                Настройки
            </h3>

            <div className="card account-page__settings-list">
                <div className="account-page__settings-item account-page__settings-item--theme">
                    <span className="account-page__settings-item-label">Оформление</span>
                    <div className="theme-toggle" role="group" aria-label="Выбор темы">
                        <button
                            type="button"
                            className={`theme-toggle__btn${theme === 'light' ? ' theme-toggle__btn--active' : ''}`}
                            onClick={() => setTheme('light')}
                            aria-pressed={theme === 'light'}
                        >
                            <IconSun size={18} stroke={1.5} />
                            Светлая
                        </button>
                        <button
                            type="button"
                            className={`theme-toggle__btn${theme === 'dark' ? ' theme-toggle__btn--active' : ''}`}
                            onClick={() => setTheme('dark')}
                            aria-pressed={theme === 'dark'}
                        >
                            <IconMoon size={18} stroke={1.5} />
                            Тёмная
                        </button>
                    </div>
                </div>
                {!isUserSet && (
                    <p className="account-page__theme-hint">По умолчанию — как в системе</p>
                )}

                <button
                    type="button"
                    className="account-page__settings-item account-page__settings-item--action"
                    onClick={onChangePassword}
                >
                    <span>Сменить пароль</span>
                    <IconChevronRight size={18} stroke={1.5} aria-hidden="true" />
                </button>

                <Link to="/subscriptions" className="account-page__settings-item account-page__settings-item--link">
                    <span>Мои подписки</span>
                    <IconChevronRight size={18} stroke={1.5} aria-hidden="true" />
                </Link>

                <Link to="/help" className="account-page__settings-item account-page__settings-item--link">
                    <span>Справка</span>
                    <IconChevronRight size={18} stroke={1.5} aria-hidden="true" />
                </Link>

                <hr className="account-page__divider" />

                <button
                    type="button"
                    className="account-page__settings-item account-page__settings-item--logout"
                    onClick={onLogout}
                >
                    Выйти
                </button>
            </div>
        </section>
    );
}
